import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: a = 16, useVw: n, useRem: c, color: o, withColor: l, removeClassName: t, disableSSR: m, style: i, ...p }) => {
  const h = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ e.createElement(x, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "24px-zhanghujiedan", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), height: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "24px-è´¦æ·ç»å"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: l ? r(o, 0, "#262933") : "#262933",
        datafollowfill: l ? r(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M15.324 1.705c-1.597-.36-2.769 1.013-2.769 2.39v4.517a2.607 2.607 0 0 0 2.607 2.608h4.518c1.377 0 2.749-1.172 2.39-2.77a8.943 8.943 0 0 0-6.746-6.745Zm-1.169 2.39c0-.284.117-.527.277-.676a.575.575 0 0 1 .54-.153 7.344 7.344 0 0 1 5.537 5.536.574.574 0 0 1-.153.54.929.929 0 0 1-.676.278h-4.518a1.007 1.007 0 0 1-1.007-1.008V4.095Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M9.973 3.975a.8.8 0 0 0-.318-1.568c-4.532.92-7.943 4.925-7.943 9.728 0 5.483 4.445 9.927 9.927 9.927 4.804 0 8.81-3.41 9.729-7.942a.8.8 0 0 0-1.568-.32 8.327 8.327 0 1 1-9.827-9.827Z"
        }
      )
    )
  )));
}, u = f;
export {
  u as default
};
